import React, { useEffect, useState } from "react";
import { Col, Card, CardBody, Row } from "reactstrap";
import { connect } from 'react-redux';
import { formatCurrency } from '../../utils/formatCurrency'


const CC_Stats = (props) => {

    const [stats, setStats] = useState(null);

    useEffect(() => {

        const deuda = props.cc.reduce((acc, item) => acc + item.balance, 0);

        const items = [
            {
                name: 'Clientes',
                value: props.cc.length,
                icon: 'group',
                color: '#3b82f6',
            },
            {
                name: 'Vehículos',
                value: props.cc_vehicles.length,
                icon: 'directions_car',
                color: '#8b5cf6',
            },
            {
                name: 'Deuda Total',
                value: formatCurrency(Math.abs(deuda)),
                icon: 'account_balance_wallet',
                color: deuda < 0 ? '#ef4444' : '#22c55e',
            }
        ]

        setStats(items);
    }, [props.cc, props.cc_vehicles]);


    if (!stats) {
        return null;
    }


    return (
        <Row className="mb-2">
            {stats.map((item, index) => (
                <Col key={index} xl={4} lg={4} md={4} sm={4} xs={12} className="mb-2">
                    <Card className="shadow-sm mb-0" style={{ borderLeft: `3px solid ${item.color}`, borderRadius: 8 }}>
                        <CardBody className="py-2 px-3">
                            <div className="d-flex align-items-center">
                                <span
                                    className="material-symbols-rounded me-3"
                                    style={{ fontSize: 28, color: item.color, opacity: 0.85 }}
                                >
                                    {item.icon}
                                </span>
                                <div>
                                    <div className="text-muted" style={{ fontSize: 12, fontWeight: 500 }}>{item.name}</div>
                                    <div style={{ fontSize: 20, fontWeight: 700, color: item.color }}>{item.value}</div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

const mapStateToProps = (state) => {
    return {
        cc: state.data.cc,
        cc_vehicles: state.data.cc_vehicles,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};


export default connect(mapStateToProps, mapDispatchToProps)(CC_Stats);
